<template>
  <div class="error-page">
    <h1>访问受限</h1>

    <p v-if="reason === 'no_token'">
      缺少有效访问凭证
    </p>
    <p v-else-if="reason === 'invalid_token'">
      访问凭证无效
    </p>
  <!--  network_error-->
    <p v-else-if="reason === 'network_error'">
      网络错误
    </p>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage',
  computed: {
    reason() {
      return this.$route.query.reason
    }
  }
}
</script>

<style scoped>
.error-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #666;
}
h1 {
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/ErrorPage.vue